import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=a20f83bc&"
import script from "./AppBar.vue?vue&type=script&lang=js&"
export * from "./AppBar.vue?vue&type=script&lang=js&"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=a20f83bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports